import { sdk } from "../redux/sdk/SDK";

/**
 * @deprecated This function is used for 3DS mocks and will be removed once the service will be part of the API
 */
export const isTest = () => {
    try {
        return sdk.api.endpoint.startsWith("http://api.int");
    } catch (error) {
        return false;
    }
};
